import { createSelector } from 'reselect';

const selectNewsLetters = (state: any) => state.newsletters;


export const selectNewsLettersCurrentItem = createSelector([selectNewsLetters], (newsletters) => newsletters.current);

export const selectNewsLettersListItems = createSelector([selectNewsLetters], (newsletters) => newsletters.list);

export const selectNewsLettersItemById = (itemId: any) =>
    createSelector(selectNewsLettersListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectNewsLettersQueryItem = createSelector([selectNewsLetters], (newsletters) => newsletters.query);

export const selectNewsLettersCreatedItem = createSelector([selectNewsLetters], (newsletters) => newsletters.create);

export const selectNewsLettersUpdatedItem = createSelector([selectNewsLetters], (newsletters) => newsletters.update);

export const selectNewsLettersReadItem = createSelector([selectNewsLetters], (newsletters) => newsletters.read);

export const selectNewsLettersDeletedItem = createSelector([selectNewsLetters], (newsletters) => newsletters.delete);

export const selectNewsLettersSearchedItems = createSelector([selectNewsLetters], (newsletters) => newsletters.search);

export const selectNewsLettersItemsCount = createSelector([selectNewsLetters], (newsletters) => newsletters.count);

export const selectNewsLettersItemsFilter = createSelector([selectNewsLetters], (newsletters) => newsletters.filter);